import { render, staticRenderFns } from "./Preference.vue?vue&type=template&id=7f00fc04&scoped=true&"
import script from "./Preference.vue?vue&type=script&lang=js&"
export * from "./Preference.vue?vue&type=script&lang=js&"
import style0 from "./Preference.vue?vue&type=style&index=0&id=7f00fc04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f00fc04",
  null
  
)

export default component.exports